export default __webpack_public_path__ + "static/media/nzlkz.1854f0cc.png";